export const paths = {
  index: "/",
  getStarted: {
    account: "/get-started-account",
    verify: "/get-started-verify",
    payment: "/get-started-payment",
    onboarding: "/get-started-onboarding",
  },
  stripeConnectRedirect: "/stripe-connect-redirect",
  checkout: "/checkout",
  contact: "/contact",
  pricing: "/pricing",
  auth: {
    jwt: {
      // magic: "/auth/magic",
      // verify: "/auth/verify",
      entry: '/auth/entry',
      entryStart: '/auth/entry/start',
    },
  },

  dashboard: {
    index: "/",
    account: "/account",
    accountTab: (tab: string) => `/account?tab=${tab}`,
    chat: "/chat",
    leads: "/leads",
    learn: "/learn",
    learning: "/learning",
    transactions: "/transactions",
    tutorials: "/tutorials",
    demo: "/demo",
    scenarios: "/scenarios",
    toolkit:"/toolkit",
    protoolkit:"/protoolkit",
    referrals:"/referrals",
    upgrade:"/upgrade",
    marketing:"/marketing",
    quiz:"/quiz",
    clientRoles: {
      index: '/clients',
      create: '/clients/create',
      edit: (ud_id: string) => `/clients/${ud_id}/edit`,
      analysis: '/clients/analysis',
      print: "/clients/print",
      printCreate: "/clients/print/create",
    },
    quitclaimDeeds: '/quitclaim-deeds',
    learnPlans: "/learn/plans",
    learnAnalysis: "/learn/analysis",
    courseDetails: (courseId: string) => `/tutorials/${courseId}`, // New path added here
  },
  resetPassword: "/reset-password/:token",
  forgotPassword: "/forgot-password",
  notAuthorized: "/401",
  notFound: "/404",
  serverError: "/500",
};
